<template>
  <CollapseSection
    title="Quiver"
    :expanded="expanded"
    :disabled="disabled"
    :loading="loading"
    section-id="Quiver"
    @toggleSection="$emit('toggleSection')"
  >

    <div class="pb-5">
        
        <div v-if="alertMessage">
            <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
        </div>

        <div class="row">
          
            <!-- Empresa -->
            <div class="col-12 col-lg-4 mb-3 pr-md-4">
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_holding">Holding</label>
                        <select v-if="editable" class="form-control" id="slt_holding"
                            v-model="dataFormEconomicQuiverConfiguration.holding_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listHoldings" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.holding?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_regional">Regional</label>
                        <select v-if="editable" class="form-control" id="slt_regional"
                            v-model="dataFormEconomicQuiverConfiguration.regional_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listRegions" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.regional?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_broker">Corretora</label>
                        <select v-if="editable" class="form-control" id="slt_broker"
                            v-model="dataFormEconomicQuiverConfiguration.broker_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listBrokers" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.broker?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_broker">Co-corretagem</label>
                        <select v-if="editable" class="form-control" id="slt_broker"
                            v-model="dataFormEconomicQuiverConfiguration.cobroker_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listCoBrokers" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.cobroker?.name || '-' }}</p>
                    </div>
                </div>
            </div>
            
            <!-- Negócio -->
            <div class="col-12 col-lg-4 pl-md-4 border-left">
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_channel">Canal</label>
                        <select v-if="editable" class="form-control" id="slt_channel"
                            v-model="dataFormEconomicQuiverConfiguration.channel_id" @change="storeQuiverConfiguration" >
                            <option :value="null"></option>
                            <option v-for="item in listChanels" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.channel?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_point_sale">Ponto de venda</label>
                        <select v-if="editable" class="form-control" id="slt_point_sale"
                            v-model="dataFormEconomicQuiverConfiguration.point_sale_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listPointOfSales" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.point_sale?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_business_line">Linhas de negócio</label>
                        <select v-if="editable" class="form-control" id="slt_business_line"
                            v-model="dataFormEconomicQuiverConfiguration.business_line_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listBusinessLines" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.business_line?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_business_origin">Origem do negócio</label>
                        <select v-if="editable" class="form-control" id="slt_business_origin"
                            v-model="dataFormEconomicQuiverConfiguration.business_origin_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listBusinessOrigins" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormEconomicQuiverConfiguration?.business_origin?.name || '-' }}</p>
                    </div>
                </div>                
            </div>
            
            <!-- Usuários -->
            <div class="col-12 col-lg-4 pl-md-4 border-left">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <label class="dbo-ui">
                            Comercial Responsável
                            <i class="fas fa-info-circle ml-2" v-b-tooltip.hover title="Produtor"></i>
                        </label>
                        <select v-if="editable" class="form-control" 
                            v-model="dataFormEconomicGroup.commercial_id" @change="storeEconomicGroup">

                            <option :value="null"></option>
                            <option v-for="item in filteredOptionsCommercial" :key="item.value" :value="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                        <p v-else>
                            {{ dataFormEconomicGroup.commercial_id ?
                                dataFormEconomicGroup?.commercial?.name + ' (' + dataFormEconomicGroup?.commercial?.email + ')' :
                                '-'
                            }}
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="group_name">Técnico</label>
                        <select v-if="editable" class="form-control" 
                            v-model="dataFormEconomicQuiverConfiguration.technical_user_id" @change="storeQuiverConfiguration">

                            <option :value="null"></option>
                            <option v-for="item in filteredOptionsCommercial" :key="item.value" :value="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                        <p v-else>
                            {{ dataFormEconomicQuiverConfiguration.technical_user_id ?
                                dataFormEconomicQuiverConfiguration?.technical_user?.name + ' (' + dataFormEconomicQuiverConfiguration?.technical_user?.email + ')' :
                                '-'
                            }}
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="group_name">Indicador</label>
                        <div class="input-group mb-2" v-if="editable">
                            <select class="form-control"
                                v-model="dataFormEconomicQuiverConfiguration.indicator_user_id" @change="storeQuiverConfiguration">
    
                                <option :value="null"></option>
                                <option v-for="item in listIndicatorUsers" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                            <div v-if="isMaster()" class="input-group-append">
                                <div class="input-group-text cursor-pointer" @click="modalUsers()">
                                    <i class="fas fa-user-edit"></i>
                                </div>
                            </div>
                        </div>
                        <p v-else>
                            {{ dataFormEconomicQuiverConfiguration.indicator_user_id ?
                                dataFormEconomicQuiverConfiguration?.indicator_user?.name + ' (' + dataFormEconomicQuiverConfiguration?.indicator_user?.email + ')' :
                                '-'
                            }}
                        </p>
                    </div>
                </div>

            </div>

        </div>
    </div>

    
    <div class="modal">
      <b-modal
        :id="'show-modal-users'"
        ref="showModalLimitHolderList"
        size="xl"
        class="mt-4"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close 
      >
        <template #modal-title>
            <h5 class="modal-title">Lista de usuários:</h5>
        </template>

        <div class="form-group row">
            <label for="inputFilter" class="col-sm-1 col-form-label col-form-label-sm">Filtrar:</label>
            <div class="col-sm-11">
                <input type="text" v-model="filterName" class="form-control form-control-sm" id="inputFilter">
            </div>
        </div>

        <div class="table-responsive">
            <b-table
                class="table-v3 custom-table custom-table-quotation no-wrap"
                sticky-header
                no-border-collapse
                :items="filtredUsers"
                :fields="fieldsListUsers"
            >
                <template #cell(name)="data">
                    <span>{{ data.item.name }}</span>
                </template>
                <template #cell(updated_at)="data">
                    <span class="centered-cell break-line">{{ formatDateTimeCustom(data.value) }}</span>
                </template>
                
                <template #cell(actions)="row">
                    <div class="centered-header">
                        <a class="text-secondary" @click="selectUserToForm(row.item.id)"
                            v-b-tooltip.hover.html title="Selecionar">
                            <i class="fas fa-check mx-2 icon-btn"></i>
                        </a>
                        <a class="text-secondary" @click="selectEditUser(row)"
                            v-b-tooltip.hover.html title="Editar">
                            <i class="fas fa-pen mx-2 icon-btn"></i>
                        </a>
                        <a class="text-secondary" @click="showModalDeleteUser(row)"
                            v-b-tooltip.hover.html title="Excluir">
                            <i class="fas fa-trash mx-2 icon-btn"></i>
                        </a>
                    </div>
                </template>
            </b-table>
        </div>

        <hr class="my-4" v-if="selectedUser">

        <fieldset v-if="selectedUser" class="mb-3">
            <legend>Detalhes do Usuário</legend>

            <div class="alert alert-danger" role="error" v-if="errorUserModal">
                {{ errorUserModal }}
            </div>
            
            <div class="row no-gutters align-items-end">
                <div class="col-md-6 form-group">
                    <label for="user_name">Nome</label>
                    <input type="text" class="form-control" id="user_name" v-model="selectedUser.name">
                </div>
                <div class="col-md-3 ml-auto text-right form-group">
                    <button @click="selectEditUser(null)" class="btn btn-outline-secondary">Cancelar</button>
                    <button @click="saveUser()" class="btn btn-md btn-primary ml-2" :disabled="loading">Salvar</button>
                </div>
            </div>
        </fieldset>

        <div class="d-flex justify-content-between" v-if="!selectedUser">
            <a @click="$bvModal.hide('show-modal-users')" class="btn btn-outline-secondary">
                <i class="fa fa-angle-left"></i> Voltar
            </a>
            
            <a @click="selectEditUser({})" class="btn btn-primary">
                Novo <i class="fa fa-plus ml-1"></i>
            </a>
        </div>
      </b-modal>
      
      <b-modal
        id="show-modal-delete-user"
        ref="modalDeleteUser"
        size="md"
        class="mt-4"
        hide-footer
        centered
      >
        <template #modal-title>
            <h5 class="modal-title">Deseja apagar esse usuário?</h5>
        </template>

        <div class="font-14 dbo-ui" v-if="selectedUserDelete">
            Deseja excluir o usuário "{{ selectedUserDelete.name }}"?
        </div>

        <div class="row pt-4">
            <div class="col-12 col-lg-12 d-flex justify-content-between">
                <button class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1" @click="closeModalDeleteUser()">
                    <span class="d-none d-md-inline-block"> Cancelar</span>
                </button>
                
                <button class="btn btn-primary btn-lg text-uppercase px-4" @click="destroyUser()">
                    Remover
                </button>
            </div>
        </div>
      </b-modal>
    </div>

  </CollapseSection>
</template>

<script>
import { CollapseSection } from "@/components";
import dateFormatterMixin from "@/mixins/dateFormatter";
import commomsHelperMixin from "@/mixins/commomsHelper";
import companyService from "@/services/company";
import authenticationService from "@/services/authentication";
import economicGroupService from "@/services/economic-group";
import quiverService from "@/services/quiver";
import brokerService from "@/services/broker";

export default {
  components: {
    CollapseSection
  },
  props: {
    expanded: Boolean,
    disabled: Boolean,
    economicGroupID: String,
    editable: { type: Boolean, default: false }
  },
  mixins: [dateFormatterMixin, commomsHelperMixin],
  data: () => ({
    loading: false,

    searchQueryCommercial: "",
    selectedCommercialData: null,
    commercialOptions: [],

    listHoldings: [],
    listPointOfSales: [],
    listRegions: [],
    listBrokers: [],
    listCoBrokers: [],
    listChanels: [],
    listBusinessLines: [],
    listBusinessOrigins: [],

    listIndicatorUsers: [],
    selectedUser: null,
    selectedUserDelete: null,
    filterName: '',
    errorUserModal: '',

    dataFormEconomicGroup: {
        commercial_id: null,
        group_name: null
    },
    dataFormEconomicQuiverConfiguration: {
        holding_id: null,
        regional_id: null,
        broker_id: null,
        channel_id: null,
        point_sale_id: null,
        business_line_id: null, 
        business_origin_id: null,
        commercial_id: null,
        indicator_user_id: null,
        technical_user_id: null
    }
  }),
  created() {
    this.resetAlert();
    if (this.expanded && this.economicGroupID) {
      this.getData();
    }
  },
  methods: {
    getData() {
        this.loading = true;

        let requests = [
            this.getEconomicGroup(),
            this.getEconomicGroupQuiverConfigurations()
        ];

        if (this.editable) {
            requests.push(this.getResponsibleCommercial());
            requests.push(this.getQuiverHoldingOptions());
            requests.push(this.getQuiverPointSaleOptions());
            requests.push(this.getQuiverBusinessLineOptions());
            requests.push(this.getQuiverBusinessOriginOptions());
            requests.push(this.getQuiverChannelOptions());
            requests.push(this.getQuiverRegionalOptions());
            requests.push(this.getQuiverRegionalOptions());
            requests.push(this.getBrokers());
            requests.push(this.getCoBrokers());
            requests.push(this.getIndicatorUsers());
        }

        Promise.all(requests)
            .finally(() => {
                this.loading = false;
            });
    },
    getEconomicGroup() {
         return companyService
            .showEconomicGroup( this.economicGroupID, {shortVersion: true})
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.dataFormEconomicGroup = response.data;
            })
            .catch((error) => {
                this.showError(error);
            });
    },
    getEconomicGroupQuiverConfigurations() {
        return economicGroupService
            .getEconomicGroupQuiverConfigurations(this.economicGroupID)
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                if (response.data?.id) {
                    this.dataFormEconomicQuiverConfiguration = response.data;
                }
            })
            .catch((error) => {
                this.showError(error);
            });
    },
    getResponsibleCommercial() {
        return companyService
            .getResponsibleCommercial()
            .then((response) => {
                if (response.data.error) {
                    return;
                }
                this.commercialOptions = response.data;
            })
            .catch(() => {
                this.showError("Não foi possível receber lista de comerciais responsáveis do grupo econômico.");
            });
    },
    storeEconomicGroup() {
        this.loading = true;
        this.dataFormEconomicGroup.cnpj = this.dataFormEconomicGroup.economic_group_cnpj;
        economicGroupService
            .updateEconomicGroup(this.economicGroupID, this.dataFormEconomicGroup)
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
            })
            .finally(() => {
                this.loading = false;
            });
        
    },
    storeQuiverConfiguration() {
        this.loading = true;
        economicGroupService
            .storeQuiverConfiguration(this.economicGroupID, this.dataFormEconomicQuiverConfiguration)
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    },
    getQuiverHoldingOptions() {
        return quiverService
            .getQuiverHoldingOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listHoldings = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de holdings.');
            });
    },
    getQuiverPointSaleOptions() {
        return quiverService
            .getQuiverPointSaleOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listPointOfSales = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de pontos de venda.');
            });
    },
    getQuiverBusinessLineOptions() {
        return quiverService
            .getQuiverBusinessLineOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listBusinessLines = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de linhas de negócio.');
            });
    },
    getQuiverBusinessOriginOptions() {
        return quiverService
            .getQuiverBusinessOriginOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listBusinessOrigins = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de origens de negócio.');
            });
    },
    getQuiverChannelOptions() {
        return quiverService
            .getQuiverChannelOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listChanels = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de canais.');
            });
    },
    getQuiverRegionalOptions() {
        return quiverService
            .getQuiverRegionalOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listRegions = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de regiões.');
            });
    },
    getCoBrokers() {
      return quiverService
        .getQuiverCoBrokersOptions()
        .then((response) => {
            if (response.data.error) {
                return;
            }
            this.listCoBrokers = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os corretores.");
        });
    },
    getBrokers() {
      return brokerService
        .get()
        .then((response) => {
            if (response.data.error) {
                console.error(response);
                return;
            }
            this.listBrokers = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os corretores.");
        });
    },
    getIndicatorUsers() {
      return quiverService
        .getQuiverIndicatorUsersOptions()
        .then((response) => {
            if (response.data.error) {
                console.error(response);
                return;
            }
            this.listIndicatorUsers = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os usuários indicadores.");
        });
    },
    isMaster() {
      return authenticationService.isMaster();
    },
    modalUsers() {
        this.getIndicatorUsers();
        this.$bvModal.show("show-modal-users");
    },
    selectEditUser(user) {
        this.selectedUser = user && user.item ? user.item : user;
        this.$bvModal.show("show-modal-users");
    },
    showModalDeleteUser(user) {
        this.selectedUserDelete = user ? user.item : null;
        this.$bvModal.show("show-modal-delete-user");
    },
    closeModalDeleteUser() {
        this.selectedUserDelete = null;
        this.$bvModal.hide("show-modal-delete-user");
    },
    saveUser() {
        this.loading = true;
        if (this.selectedUser.id) {
            quiverService
                .updateQuiverIndicatorUser(this.selectedUser.id, this.selectedUser)
                .then(() => {
                    this.getIndicatorUsers();
                    this.selectedUser = null;
                    this.loading = false;
                })
                .catch(() => {
                    this.errorUserModal = 'Não foi possível salvar o usuário indicador.';
                });
            return;
        } else {
            quiverService
                .storeQuiverIndicatorUser(this.selectedUser)
                .then(() => {
                    this.getIndicatorUsers();
                    this.selectedUser = null;
                    this.loading = false;
                })
                .catch(() => {
                    this.errorUserModal = 'Não foi possível salvar o usuário indicador.';
                });
        }
    },
    destroyUser() {
        if (!this.selectedUserDelete?.id) {
            return;
        }
        quiverService
            .destroyQuiverIndicatorUser(this.selectedUserDelete.id)
            .then(() => {
                this.getIndicatorUsers();
                this.selectedUserDelete = null;
                this.$bvModal.hide("show-modal-delete-user");
            })
            .catch(() => {
                this.showError('Não foi possível excluir o usuário indicador.');
            });
    },
    selectUserToForm(userId) {
        this.dataFormEconomicQuiverConfiguration.indicator_user_id = userId;
        this.$bvModal.hide("show-modal-users");
        this.storeQuiverConfiguration();
    },
  },
  computed: {
      selectedCommercial() {
          return (this.selectedCommercialData || { text: "Informe o usuário" });
      },
      filteredOptionsCommercial() {
          return [
            // { text: 'Nenhuma opção.', value: '' },
            ...this.commercialOptions.filter((option) =>
                option.text.toLowerCase().includes(this.searchQueryCommercial.toLowerCase())
            )
          ];
      },
      filtredUsers() {
          return this.listIndicatorUsers.filter((user) =>
              user.name.toLowerCase().includes(this.filterName.toLowerCase())
          );
      },
    fieldsListUsers() {
      return [
        {
          key: "name",
          label: "Nome",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui centered-header",
        },
        {
          key: "updated_at",
          label: "Última atualização",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui width-150px centered-header",
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: "font-14 ",
          thClass: "table-pretty dbo-ui width-150px centered-header",
        },
      ];
    },
  },
  watch: {
    expanded: function (value) {
      if (value) {
        this.resetAlert();
        this.getData();
      }
    },
  },
};
</script>
<style></style>
